import React from "react"

import Chart from "./StackedAreaChart.d3"
import ChartWrapper from "../ChartWrapper"

const StackedAreaChart = ({
  data,
  inModal,
  chartId,
  stackKeys,
  relations,
  setSelection = () => {},
  showComposition,
}) => {
  const updateProps = React.useMemo(() => ({ data, showComposition, stackKeys }), [data, showComposition, stackKeys])

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{ data, relations, stackKeys, inModal, setSelection, chartId }}
      updateProps={updateProps}
      margin={{ BOTTOM: 20, LEFT: 40, TOP: 20  }}
    />
  )
}

export default StackedAreaChart
